import { MetaHandler } from "@/main/common/MetaHandler";
import { getSensitivePreferenceMode, shouldMaskSensitiveMedia } from "@/main/common/SensitivePreference";

/**
 * `GROUP-113` / round 39 `1d` (D18), widened by `GROUP-117` (A42, mega solo `mr2-group`): whether a person's
 * photo must give way to the plain letter avatar at a spot too small, or too link-like, for
 * `SensitiveMediaGuard`'s overlay and reveal.
 *
 * <p>Same predicate as the guard: the person is sensitive, the viewer's preference is not SHOW, and the viewer
 * is not that person (the owner exemption `UserCardDisplayer` applies). `sensitive` absent reads as not
 * sensitive, so a payload that does not carry the flag yet renders exactly as before.
 *
 * <p>One helper for every such site (the group header byline, the Leaders chip, the About tab's Leaders card
 * and Recent posts rows), so the same person never has two faces on one page.
 */
export function masksPersonAvatar(person?: { username?: string | null; sensitive?: boolean | null } | null): boolean {
    if (!person?.sensitive) return false;
    const username = person.username?.trim();
    if (username && username === MetaHandler.getLoggedInUsername()?.trim()) return false;
    return shouldMaskSensitiveMedia(true, getSensitivePreferenceMode());
}
